import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate, labelize } from "@/lib/constants";

export default function MyActivity() {
  const [rows, setRows] = useState([]);
  const [me, setMe] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setMe(r.data.user));
  }, []);

  useEffect(() => {
    if (!me) return;
    api.get(`/employees/${me.id}/activity`).then((r) => setRows(r.data.audit));
  }, [me]);

  return (
    <div>
      <div className="label-mono">Recent activity</div>
      <h1 className="font-chivo font-black text-4xl md:text-5xl uppercase tracking-tighter leading-none">My activity</h1>

      <div className="brut-card mt-4 overflow-x-auto">
        <table className="w-full text-sm font-mono min-w-[720px]">
          <thead>
            <tr className="border-b border-black text-[10px] uppercase tracking-widest">
              <th className="py-2 px-4 text-left">When</th>
              <th className="py-2 px-4 text-left">Action</th>
              <th className="py-2 px-4 text-left">Target</th>
              <th className="py-2 px-4 text-left">IP</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-zinc-200">
                <td className="py-2 px-4 text-[11px]">{fmtDate(r.created_at)}</td>
                <td className="py-2 px-4">{labelize(r.action)}</td>
                <td className="py-2 px-4">{r.target_type} · <span className="text-zinc-500">{r.target_id?.slice(0, 12)}</span></td>
                <td className="py-2 px-4">{r.ip_address || "—"}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={4} className="py-6 text-center label-mono">No recent activity</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
